import PageTemplate from '../../components/feature/PageTemplate';
import SharedProcessSection from '../../components/feature/SharedProcessSection';
import SharedFAQSection from '../../components/feature/SharedFAQSection';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AIAnswerBlock from './components/AIAnswerBlock';

const PROCESS_STEPS = [
  {
    icon: 'ri-search-eye-line',
    title: 'Free Inspection',
    desc: 'Our certified inspector evaluates your roof thoroughly — assessing damage, wear, and structural integrity at zero cost to you.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Detailed Estimate',
    desc: 'You receive a transparent, itemized estimate with no hidden fees. Every line item explained in plain language before work begins.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Material Selection',
    desc: 'Choose from our premium roofing materials — asphalt, metal, flat systems — with expert guidance for Utah\'s climate.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Installation',
    desc: 'Experienced crews complete your project efficiently and cleanly, following all Utah building codes and manufacturer specs.',
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Final Walkthrough',
    desc: 'We walk you through the completed roof, ensuring everything meets our standards and your expectations before we leave.',
  },
];

const FAQS = [
  {
    q: 'Who provides roofing services near me in Utah?',
    a: 'IWC Roofing Utah provides professional roofing services across Salt Lake City and Northern Utah, specializing in residential roof repair, replacement, commercial roofing, and storm damage restoration. Our locally based crews serve all major Utah communities with fast response times and expert craftsmanship tailored to Utah\'s climate.',
  },
  {
    q: 'How much does a roof replacement cost in Utah?',
    a: 'Residential roof replacement in Utah typically ranges from $8,000 to $25,000 depending on home size, roofing material, and project complexity. Metal roofing and premium systems cost more but offer longer lifespans. IWC Roofing provides free, fully itemized estimates so there are never any surprises before work begins.',
  },
  {
    q: 'What is the best roofing option for Utah homes?',
    a: 'Architectural asphalt shingles are the most popular choice for Utah homes, offering excellent performance in heavy snow, summer heat, and hail. Metal roofing provides maximum longevity at a higher upfront cost. IWC Roofing helps you select the ideal material based on your budget, home style, and Utah climate requirements.',
  },
  {
    q: 'How long does roof replacement take?',
    a: 'Most residential roof replacements in Utah are completed within one to three days. Larger or more complex roofs may require additional time depending on weather. IWC Roofing schedules projects efficiently with full-day crews to minimize disruption while maintaining the high quality standards every customer deserves.',
  },
  {
    q: 'Should I repair or replace my roof?',
    a: 'Repairs make sense for roofs under fifteen years old with isolated, minor damage. Full replacement becomes more cost-effective when your roof has widespread damage, repeated leaking, or is over twenty to twenty-five years old. A free IWC Roofing inspection provides a clear, honest recommendation for your specific situation.',
  },
  {
    q: 'Does IWC Roofing help with insurance claims?',
    a: 'Yes — IWC Roofing Utah specializes in insurance claim support for storm and hail damage. We document all damage professionally, provide insurance-format estimates, attend adjuster meetings on your behalf, and work to maximize your coverage so you receive the full value your homeowners policy provides.',
  },
  {
    q: 'Is IWC Roofing licensed and insured in Utah?',
    a: 'IWC Roofing Utah holds a valid Utah contractor license and carries comprehensive general liability insurance and workers\' compensation coverage on all projects. We are happy to provide proof of licensing and insurance upon request before any work begins on your property or home.',
  },
  {
    q: 'How do I know if my roof needs replacing?',
    a: 'Warning signs include missing or curling shingles, granule loss visible in gutters, interior water stains, a sagging roof deck, or a roof older than twenty to twenty-five years. Our free professional inspection provides an honest, detailed assessment of your roof\'s condition and the best recommended next steps.',
  },
];

export default function HomePage() {
  return (
    <PageTemplate
      hero={<HeroSection />}
      mainSection={<ServicesSection />}
      aiBlock={<AIAnswerBlock />}
      processSection={
        <SharedProcessSection
          title="Our Proven Roofing Process"
          subtitle="Simple, transparent, and stress-free — from first call to final walkthrough."
          steps={PROCESS_STEPS}
        />
      }
      faqSection={
        <SharedFAQSection
          title="Roofing Questions Answered"
          faqs={FAQS}
        />
      }
      midCTA1="Ready to protect your Utah home with a quality roof?"
      midCTA2="Simple process, zero pressure — get your free estimate today."
      midCTA3="Join 1,200+ satisfied Utah homeowners — get started today."
    />
  );
}
